export const baseUrl = `${process.env.REACT_APP_BACKEND_URL}`;
export const recaptchaSiteKey = `${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;